export const RAISING_HANDS =
  'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/other/raising_hands.png';

export const PHONE = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/icons/phone.svg';

export const TELEGRAM_LOGO = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/icons/tg.svg';

export const EMAIL = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/icons/mail.svg';
